Components.HeaderView = {
    bindings: {
        backButton: '&?',
        breadcrumbBaseTitle: '@?',
        breadcrumbBaseState: '@?',
        breadcrumbTitleView: '@?',
        showSavingIndicator: '=',
        savingIndicatorModel: '=',
        currentTemplate: '=',
        ctaRightButton: '&?',
        showCtaRightButton: '<?',
        contentClass: '@?'
    },
    transclude: true,
    // @ngInject
    controller: function TabsController($scope, $state, $translate, DeviceService){

        this.$translate = $translate;
        this.handleClickBack = function handleClickBack() {
            this.backButton();
        };

        this.showOnlyTitleOnHeader = DeviceService.nxSmallBreakpoint() && (
                                $state.params.templateModelKey === 'contactForm' || 
                                $state.params.templateModelKey === 'giftCard'
                              );
        
        this.isGiftCard = $state.params.templateModelKey === 'giftCard';
        
        this.goToBase = function goToBase() {
            if (this.breadcrumbBaseState) {
                $state.go(this.breadcrumbBaseState)
            } else {
                this.handleClickBack();
            }

        };

        this.breadcrumbTitleViewTranslated = function breadcrumbTitleViewTranslated() {
            return this.$translate.instant(this.breadcrumbTitleView);
        }

    },
    name: 'hbHeaderView',
    templateUrl: 'angular/app/modules/common/ui_components/header_view/header_view_component_template.html',
}